import { useMemo } from "react";
import { useFirestoreCollection } from "./useFirestoreCollection";

export const useObjects = (projectId: string) => {
  const [unsortedObjects, isLoading] = useFirestoreCollection(
    ["projects", projectId, "objects"].join("/")
  );

  const objects = useMemo(
    () =>
      [...unsortedObjects].sort((a, b) =>
        (a.get("title") as string ?? "").localeCompare(b.get("title") ?? "", undefined, {
          numeric: true,
          sensitivity: "base",
        })
      ),
    [unsortedObjects]
  );


  return [objects, isLoading] as const;
};
